module.exports = __webpack_public_path__ + "img/336.ba690629.png";